import { AlertTriangle } from "lucide-react"
import { useEffect, useRef } from "react"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

interface LimitReachedModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
}

export function LimitReachedModal({
  open,
  onOpenChange,
  title,
  description,
}: LimitReachedModalProps) {
  const buttonRef = useRef<HTMLButtonElement>(null)

  // Focus button when dialog opens, avoiding timing races with animations
  useEffect(() => {
    if (open) {
      buttonRef.current?.focus()
    }
  }, [open])

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="text-yellow h-5 w-5" />
            {title.toUpperCase()}
          </DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            ref={buttonRef}
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Got It
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
